export const CATEGORIES = [
  {
    key: "movie",
    label: "电影",
    en: "Films",
    desc: "院线新片与经典长片，收录剧情、演职员与幕后",
    icon: "ri-film-line",
  },
  {
    key: "tv",
    label: "电视剧",
    en: "Series",
    desc: "热播剧集与年代佳作，逐集梳理剧情走向",
    icon: "ri-tv-2-line",
  },
  {
    key: "variety",
    label: "综艺",
    en: "Variety",
    desc: "美食、访谈与文化节目，记录真实的生活现场",
    icon: "ri-mic-line",
  },
  {
    key: "animation",
    label: "动画",
    en: "Animation",
    desc: "手绘与国创动画，献给仍然相信想象的人",
    icon: "ri-palette-line",
  },
];

export const REGIONS = ["全部地区", "中国大陆", "美国", "英国", "法国", "韩国", "日本"];

export const YEARS = ["全部年份", "2025", "2024", "2023", "2022"];

export const SORTS = [
  { key: "updated", label: "最近更新" },
  { key: "popular", label: "热度最高" },
  { key: "rating", label: "评分最高" },
];

export const NAV_LINKS = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/variety", label: "综艺" },
  { to: "/category/animation", label: "动画" },
  { to: "/news", label: "影视动态" },
  { to: "/contact", label: "联系我们" },
];